import graphql from "babel-plugin-relay/macro";

export const LogOutMutationString = graphql`
  mutation LogOutMutation {
    responsePayload: logOut {
      success
      errors {
        code

        message
        field
      }
    }
  }
`;
